import { Component } from '@angular/core';
import {
	DepositHolder,
	DepositHolderOptions,
	MatterPropertyType,
	PropertyStatus,
} from '@models/matter';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { cloneDeep } from 'lodash';
import { Observable } from 'rxjs';

export const getDepositHolderOptions = (propertyStatus: PropertyStatus) => {
	const depositOptions = cloneDeep(DepositHolderOptions);
	if (propertyStatus === PropertyStatus.NEW) {
		depositOptions.push({
			label: 'Builder',
			value: DepositHolder.BUILDER,
		});
	}

	return depositOptions;
};

@UntilDestroy()
@Component({
	selector: 'app-deposit-holder',
	templateUrl: './deposit-holder.component.html',
	standalone: false,
})
export class DepositHolderComponent {
	public depositHolders;

	@ViewSelectSnapshot(SelectedMatter.id) saleId: string;
	@ViewSelectSnapshot(SelectedMatter.getSelectedDepositHolder)
	depositHolder: DepositHolder;
	@Select(SelectedMatter.propertyType)
	propertyType$: Observable<MatterPropertyType>;

	public orientation;
	constructor(private matterDispatch: MatterDispatch) {
		this.propertyType$.pipe(untilDestroyed(this)).subscribe((propertyType) => {
			// if property status is different from new, builder should not be selected as a deposit holder

			if (
				propertyType &&
				propertyType?.status !== PropertyStatus.NEW &&
				this.depositHolder === DepositHolder.BUILDER
			) {
				this.matterDispatch.SetDepositHolder(this.saleId, null);
			}
			this.depositHolders = getDepositHolderOptions(propertyType?.status);
			this.orientation =
				this.depositHolders?.length >= 4 ? 'grid' : 'horizontal';
		});
	}

	onDepositHolderChange($event) {
		this.matterDispatch.SetDepositHolder(this.saleId, $event);
	}
}
